const globalApiParams = {
  page: 1,
  pageSize: 30,
  maxFilterPageSize: 3000,
  title: '',
};

export { globalApiParams };
